define('shared/initializer/form/newHouseAdapters/mixins/PaymentSuccessHandlable',[
    'shared/lib/RSVP',
    'shared/util/checkout/checkout'
], 
function(
    RSVP,
    checkout
){
    function Ctor() {}

    Ctor.prototype.doBeforeRedirect = function(data) {
        if (!data || !data.Order_id) {
            return RSVP.resolve(data);
        }
        return RSVP.resolve()
            .then(function(){
                return checkout.handlePaymentSucceeded(data.Order_id);
            })
            .then(function(){
                return data;
            });
    };

    return Ctor;
});
